import { render, staticRenderFns } from "./CartPriceCard.vue?vue&type=template&id=0c01d5ec&scoped=true&"
import script from "./CartPriceCard.vue?vue&type=script&lang=js&"
export * from "./CartPriceCard.vue?vue&type=script&lang=js&"
import style0 from "./CartPriceCard.vue?vue&type=style&index=0&id=0c01d5ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c01d5ec",
  null
  
)

export default component.exports